// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","Container":"Container_z9Ex9","ActiveProduct":"ActiveProduct_oHErv"};